import axios from "axios";
import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { useLocation, useParams } from "react-router-dom";
import Breadcrumb from "../Component/BradeCrum";
import HeaderMobile from "../Component/MobileHader";
import { Hourglass } from "react-loader-spinner";


const ComanPage = () => {
  const location = useLocation();
  const [content, setContent] = useState([]);
  const [title, setTitle] = useState("")
      const [loading, setLoading] = useState(true);
  
  
  useEffect( ()=>{
    // setLoading(true)
    let currentPath = location.pathname;
    currentPath = currentPath.split("/")[1]

    setTitle(currentPath);
    axios.get(`${process.env.REACT_APP_GRIPHOLD_API_URL}/api/auth/getCMS/cmss/${currentPath}`)
    .then((res)=>
      setContent(res.data),

    )
  },[location])


   useEffect(() => {
      window.scrollTo(0, 0);
      const timer = setTimeout(() => {
        setLoading(false);
      }, 2000); // Adjust loading duration
  
      return () => clearTimeout(timer);
    }, []);
  return (
    <React.Fragment>
         {loading ? (
                        
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    height: "100vh",
                                  }}
                                >
                                  <Hourglass
                                    height={80}
                                    width={80}
                                    color="#01458e"
                                    ariaLabel="loading-content"
                                  />
                                </div>
                              ) : (
      <div>
      <HeaderMobile/>
      <Breadcrumb heading={title} midTitle='About us' bTitle={title}/>
      <Container className="galleryRow ">
      <div className="sub-title  text-animation">
                <h6>
                  {title}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={50}
                    height={6}
                    viewBox="0 0 50 6"
                  >
                    <path d="M50 3L45 0.113249V5.88675L50 3ZM0 3.5H45.5V2.5H0V3.5Z" />
                  </svg>
                </h6>
             
              </div>
      {content.length > 0 &&<div
      className="aboutdescription"
          dangerouslySetInnerHTML={{ __html: content[0].Description }}>
        </div>}
      </Container>
      </div>
       )}
    </React.Fragment>
  );
};

export default ComanPage;
